import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
  gap: '0.5rem',
  padding: '1rem',
})

export const StyledTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const StyledResult = styled('div', ({ $theme }) => ({
  fontWeight: '600',
  fontSize: '0.875rem',
  lineHeight: '160%',
  color: $theme.colors.textDeep,
}))
